<template></template>

<script>
export default {
    props: ['data'],

    computed: {
        structuredData() {
            return {
                '@context': 'https://schema.org',
                '@type': 'HowTo',
                name: this.data.title,
                description: this.data.description.replace(/<[^>]*>?/gm, ''),
                step: this.steps,
            };
        },

        steps() {
            if (this.data.steps) {
                return this.data.steps.map(step => {
                    if (step.text) {
                        return {
                            '@type': 'HowToStep',
                            image: `${this.$config.images.baseUrl}/resources/images/${step.image}`,
                            text: step.text.replace(/<[^>]*>?/gm, ''),
                        };
                    } else {
                        return {
                            '@type': 'HowToStep',
                            text: step.replace(/<[^>]*>?/gm, ''),
                        };
                    }
                });
            } else {
                return null;
            }
        },
    },

    head() {
        if (this.steps && this.steps.length) {
            return {
                script: [{ type: 'application/ld+json', json: this.structuredData, body: true }],
            };
        }
    },
};
</script>
